/**
 * TODO: Refactor for clearer behavior.
 * Should it be a just trigger for multiple functions?
 * Should it be a proper chain and submit previous funtions results to new ones?
 */
export var chainHandlers = function () {
    var handlers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        handlers[_i] = arguments[_i];
    }
    return function (e) {
        return handlers.reduce(function (result, handler) { return (handler ? handler(e) : result); }, null);
    };
};
//# sourceMappingURL=chain-handlers.js.map